const items = [
    "3 Simulazioni Complete",
    "120 Quesiti",
    "40 Quesiti per Prova",
    "60 Minuti per Test",
    "Quesiti di Conoscenza",
    "Logico-Deduttivi",
    "Situazionali",
    "Correzioni Commentate",
    "Riferimenti Normativi",
    "Piano di Ripasso Finale",
];

export const Marquee = () => (
    <div className="relative overflow-hidden border-y border-white/10 bg-[#071731] py-4">
        <div className="animate-marquee flex w-max items-center gap-10">
            {[...items, ...items].map((t, i) => (
                <span key={i} className="flex items-center gap-10 whitespace-nowrap">
                    <span className="font-display text-xs font-bold uppercase tracking-[0.2em] text-slate-300">{t}</span>
                    <span className="h-1.5 w-1.5 rotate-45 bg-gold" />
                </span>
            ))}
        </div>
    </div>
);
